import { PlateInfoDTO } from 'business/models/Models';
import PlateService from 'business/services/PlateService';
import { ButtonsListContainer } from 'components/Button';
import RMCustomButton, {
  RMCustomButtonProps,
} from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import React, { useEffect, useState } from 'react';
import { IStyle } from 'Styles';
import { showAlertSnackBar } from 'utils/Global';

const plateService = new PlateService();
interface Props {
  plate: PlateInfoDTO;
  updateBarcode: (text: string) => void;
  hideModal: () => void;
}
const EditBarcodeModalBody = (props: Props) => {
  const { plate, hideModal, updateBarcode } = props;
  const [newBarcode, setNewBarcode] = useState<string>(plate.barcode);
  const [defaultBarcode, setDefaultBarcode] = useState('');
  const savedBarcode = plate.barcode;
  const isUndoDisabled = newBarcode === savedBarcode;
  const isResetDisabled = !defaultBarcode.length;

  const actionButtons: RMCustomButtonProps[] = [
    {
      title: 'CANCEL',
      contentContainerClass: 'btn-outline-yellow-wide h-full',
      buttonMainContainerStyle: styles.actionButtonStyles,
      onClick: () => hideModal(),
    },
    {
      title: 'CONFIRM',
      contentContainerClass: 'bg-[#F7A246] w-[9.5rem] !text-[#ffffff] h-full',
      buttonMainContainerStyle: styles.actionButtonStyles,
      onClick: () => {
        updateBarcode(newBarcode);
      },
    },
  ];

  useEffect(() => {
    const setDefaultBarcodeAsync = async () => {
      if (plate) {
        const _defaultBarcode = await plateService.GetPlateDefaultBarcode(plate.id);
        setDefaultBarcode(_defaultBarcode.barcode);
      }
    };
    setDefaultBarcodeAsync();
  }, [plate]);

  const keyDownHandler = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      updateBarcode(newBarcode);
    }
  };
  useEffect(() => {
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [keyDownHandler]);
  return (
    <div
      id={`editbarcodemodalbody-wrapper-${plate.id}`}
      className="d-flex flex-column h-full"
    >
      <div id={`editbarcodemodalbody-label-${plate.id}`}>Input Barcode</div>
      <div id={`editbarcodemodalbody-input-row-${plate.id}`} className="flex flex-row">
        <input
          id={`editbarcodemodalbody-input-${plate.id}`}
          type="text"
          className="w-full"
          value={newBarcode}
          onChange={(e) => {
            if (e.target.value.length > 50) {
              showAlertSnackBar(
                EAlertType.WARNING,
                ESnackBarPosition.TOP,
                'Barcode length should not exceed 50 characters.',
              );
            } else {
              setNewBarcode(e.target.value);
            }
          }}
          autoFocus
        />
        <RMCustomButton
          title="UNDO"
          mainContainerClass={`${
            isUndoDisabled ? 'bg-[#cacaca]' : 'bg-[#313131]'
          } px-2 py-1 rounded-md ml-2`}
          titleClass={`${isUndoDisabled ? 'text-[#9b9b9b]' : 'text-white'} font-semibold`}
          isDisabled={isUndoDisabled}
          onClick={() => {
            setNewBarcode(savedBarcode);
          }}
        />
        <RMCustomButton
          title="RESET"
          mainContainerClass={`${
            isResetDisabled ? 'bg-[#cacaca]' : 'bg-[#313131]'
          } px-2 py-1 rounded-md ml-2`}
          titleClass={`${
            isResetDisabled ? 'text-[#9b9b9b]' : 'text-white'
          } font-semibold`}
          isDisabled={isResetDisabled}
          onClick={() => {
            setNewBarcode(defaultBarcode);
          }}
        />
      </div>
      <ButtonsListContainer
        containerStyleClass="my-3 justify-end"
        marginBetweenItems={4}
        buttonsList={actionButtons}
      />
    </div>
  );
};

export default EditBarcodeModalBody;
const styles: IStyle = {
  actionButtonStyles: {
    display: 'flex',
    textTransform: 'uppercase',
    height: '2rem',
    minHeight: '2rem',
    maxHeight: '2rem',
    fontSize: '1rem',
    borderRadius: '0.375rem',
  },
};
